import css from './numberInput.module.css'
import cn from '@/utils/cn.ts'
import { useState } from 'react'

interface IProps {
  error?: boolean
  inscription?: string
  placeHolder?: string
  hideInnerSpinButton?: boolean
  disabled?: boolean
  fullWidth?: boolean
  value: number
  name: string
  onChange: (val: number, name: string) => void
}

const NumberInput = (props: IProps) => {
  const [value, setValue] = useState('')

  const handleBlur = () => {
    if (Number.isNaN(+value)) {
      setValue(props.value?.toString())
    } else {
      props.onChange(+value, props.name)
    }
  }

  return (
    <div className="flex-lines gap4" style={{ width: props.fullWidth ? '100%' : '90px' }}>
      <input
        value={value}
        onChange={(ev) => setValue(ev.target.value)}
        disabled={Boolean(props.disabled)}
        data-error={Boolean(props.error)}
        className={cn(css.input, 'text-nm')}
        placeholder={props.placeHolder}
        type="number"
        onBlur={handleBlur}
        data-hide-inner-spin={Boolean(props.hideInnerSpinButton)}
      />
      {Boolean(props.inscription) && <p className="text-lg text-description">{props.inscription}</p>}
    </div>
  )
}

export default NumberInput
